// frontend/src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginForm from './LoginForm';
import AdminDashboard from './components/dashboards/AdminDashboard';
import OwnerDashboard from './components/dashboards/OwnerDashboard';
import SupervisorDashboard from './components/dashboards/SupervisorDashboard';
import TherapistDashboard from './components/dashboards/TherapistDashboard';
import PatientDashboard from './components/dashboards/PatientDashboard';
import ProtectedRoute from './ProtectedRoute';
import './styles/LoginForm.css';

function App() {
  return (
    <AuthProvider>
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/admin/*" element={
          <ProtectedRoute allowedRoles={['ADMIN']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/owner/*" element={
          <ProtectedRoute allowedRoles={['OWNER']}>
            <OwnerDashboard />
          </ProtectedRoute>
        } />
        <Route path="/supervisor/*" element={
          <ProtectedRoute allowedRoles={['SUPERVISOR']}>
            <SupervisorDashboard />
          </ProtectedRoute>
        } />
        <Route path="/therapist/*" element={
          <ProtectedRoute allowedRoles={['THERAPIST']}>
            <TherapistDashboard />
          </ProtectedRoute>
        } />
        <Route path="/patient/*" element={
          <ProtectedRoute allowedRoles={['PATIENT']}>
            <PatientDashboard />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </AuthProvider>
  );
}

export default App;
